export default "__VITE_ASSET__DCP7HqP2__"